const calentadores = {
  lp: {
    C6L: "8350620418321", // 1 servicio
    C8L: "8350620483857", // 1.5 servicios
    C12L: "8350620582161", // 2 servicios
    C16L: "8350620647697", // 3 servicios
    CM14: "8350620713233", // 2.5 servicios
    CM24: "8350620778769", // 4 servicios
  },
  natural: {
    C6LNAT: "8350620385553",
    C8LNAT: "8350620451089",
    C12LNAT: "8350620516625",
    C16LNAT: "8531198345489",
    CM14NAT: "8350620680465",
    CM24NAT: "8350620746001",
  },
};

document.addEventListener("DOMContentLoaded", function () {
  let tipo = "";
  let distancia = "";
  let servicio = "";
  const step1 = document.getElementById("step-1");
  const step2 = document.getElementById("step-2");
  const step3 = document.getElementById("step-3");
  const step4 = document.getElementById("step-4");
  const step5 = document.getElementById("step-5");
  const next1 = document.getElementById("next-1");
  const natural = document.getElementById("natural");
  const lp = document.getElementById("lp");
  const corta = document.getElementById("corta");
  const mediana = document.getElementById("mediana");
  const larga = document.getElementById("largo");
  const service1 = document.getElementById("servicio-1");
  const service2 = document.getElementById("servicio-2");
  const service3 = document.getElementById("servicio-3");
  const service4 = document.getElementById("servicio-4");
  const service5 = document.getElementById("servicio-5");
  const service6 = document.getElementById("servicio-6");

  // paso 1
  next1.addEventListener("click", function () {
    step1.classList.add("css-hidden");
    step2.classList.remove("css-hidden");
  });

  // paso 2
  natural.addEventListener("click", function () {
    step2.classList.add("css-hidden");
    step3.classList.remove("css-hidden");
    tipo = "natural";
  });
  lp.addEventListener("click", function () {
    step2.classList.add("css-hidden");
    step3.classList.remove("css-hidden");
    tipo = "lp";
  });

  // paso 3
  corta.addEventListener("click", function () {
    step3.classList.add("css-hidden");
    step4.classList.remove("css-hidden");
    distancia = "corta";
  });
  mediana.addEventListener("click", function () {
    step3.classList.add("css-hidden");
    step4.classList.remove("css-hidden");
    distancia = "mediana";
  });
  larga.addEventListener("click", function () {
    step3.classList.add("css-hidden");
    step4.classList.remove("css-hidden");
    distancia = "largo";
  });

  // paso 4
  service1.addEventListener("click", function () {
    step4.classList.add("css-hidden");
    step5.classList.remove("css-hidden");
    servicio = "1";
    if (tipo === "lp") {
      if (distancia === "corta") {
        const el = document.getElementById(`css-${calentadores.lp.C6L}`);
        el.classList.remove("css-hidden");
      } else if (distancia === "mediana") {
        const el = document.getElementById(`css-${calentadores.lp.C8L}`);
        el.classList.remove("css-hidden");
      } else if (distancia === "largo") {
        const el = document.getElementById(`css-${calentadores.lp.C12L}`);
        el.classList.remove("css-hidden");
      }
    } else if (tipo === "natural") {
      if (distancia === "corta") {
        const el = document.getElementById(
          `css-${calentadores.natural.C6LNAT}`
        );
        el.classList.remove("css-hidden");
      } else if (distancia === "mediana") {
        const el = document.getElementById(
          `css-${calentadores.natural.C8LNAT}`
        );
        el.classList.remove("css-hidden");
      } else if (distancia === "largo") {
        const el = document.getElementById(
          `css-${calentadores.natural.C12LNAT}`
        );
        el.classList.remove("css-hidden");
      }
    }
  });
  service2.addEventListener("click", function () {
    step4.classList.add("css-hidden");
    step5.classList.remove("css-hidden");
    servicio = "1.5";
    if (tipo === "lp") {
      if (distancia === "corta") {
        const el = document.getElementById(`css-${calentadores.lp.C8L}`);
        el.classList.remove("css-hidden");
      } else if (distancia === "mediana") {
        const el = document.getElementById(`css-${calentadores.lp.C12L}`);
        el.classList.remove("css-hidden");
      } else if (distancia === "largo") {
        const el = document.getElementById(`css-${calentadores.lp.C16L}`);
        el.classList.remove("css-hidden");
      }
    } else if (tipo === "natural") {
      if (distancia === "corta") {
        const el = document.getElementById(
          `css-${calentadores.natural.C8LNAT}`
        );
        el.classList.remove("css-hidden");
      } else if (distancia === "mediana") {
        const el = document.getElementById(
          `css-${calentadores.natural.C12LNAT}`
        );
        el.classList.remove("css-hidden");
      } else if (distancia === "largo") {
        const el = document.getElementById(
          `css-${calentadores.natural.C16LNAT}`
        );
        el.classList.remove("css-hidden");
      }
    }
  });
  service3.addEventListener("click", function () {
    step4.classList.add("css-hidden");
    step5.classList.remove("css-hidden");
    servicio = "2";
    if (tipo === "lp") {
      if (distancia === "corta") {
        const el = document.getElementById(`css-${calentadores.lp.C12L}`);
        el.classList.remove("css-hidden");
      } else if (distancia === "mediana") {
        const el = document.getElementById(`css-${calentadores.lp.C16L}`);
        el.classList.remove("css-hidden");
      } else if (distancia === "largo") {
        const el = document.getElementById(`css-${calentadores.lp.CM14}`);
        el.classList.remove("css-hidden");
      }
    } else if (tipo === "natural") {
      if (distancia === "corta") {
        const el = document.getElementById(
          `css-${calentadores.natural.C12LNAT}`
        );
        el.classList.remove("css-hidden");
      } else if (distancia === "mediana") {
        const el = document.getElementById(
          `css-${calentadores.natural.C16LNAT}`
        );
        el.classList.remove("css-hidden");
      } else if (distancia === "largo") {
        const el = document.getElementById(
          `css-${calentadores.natural.CM14NAT}`
        );
        el.classList.remove("css-hidden");
      }
    }
  });
  service4.addEventListener("click", function () {
    step4.classList.add("css-hidden");
    step5.classList.remove("css-hidden");
    servicio = "2.5";
    if (tipo === "lp") {
      if (distancia === "corta") {
        const el = document.getElementById(`css-${calentadores.lp.CM14}`);
        el.classList.remove("css-hidden");
      } else if (distancia === "mediana") {
        const el = document.getElementById(`css-${calentadores.lp.C16L}`);
        el.classList.remove("css-hidden");
      } else if (distancia === "largo") {
        const el = document.getElementById(`css-${calentadores.lp.CM24}`);
        el.classList.remove("css-hidden");
      }
    } else if (tipo === "natural") {
      if (distancia === "corta") {
        const el = document.getElementById(
          `css-${calentadores.natural.CM14NAT}`
        );
        el.classList.remove("css-hidden");
      } else if (distancia === "mediana") {
        const el = document.getElementById(
          `css-${calentadores.natural.C16LNAT}`
        );
        el.classList.remove("css-hidden");
      } else if (distancia === "largo") {
        const el = document.getElementById(
          `css-${calentadores.natural.CM24NAT}`
        );
        el.classList.remove("css-hidden");
      }
    }
  });
  service5.addEventListener("click", function () {
    step4.classList.add("css-hidden");
    step5.classList.remove("css-hidden");
    servicio = "3";
    if (tipo === "lp") {
      if (distancia === "largo") {
        const el = document.getElementById(`css-${calentadores.lp.CM24}`);
        el.classList.remove("css-hidden");
      } else {
        const el = document.getElementById(`css-${calentadores.lp.C16L}`);
        el.classList.remove("css-hidden");
      }
    } else if (tipo === "natural") {
      if (distancia === "largo") {
        const el = document.getElementById(
          `css-${calentadores.natural.CM24NAT}`
        );
        el.classList.remove("css-hidden");
      } else {
        const el = document.getElementById(
          `css-${calentadores.natural.C16LNAT}`
        );
        el.classList.remove("css-hidden");
      }
    }
  });
  service6.addEventListener("click", function () {
    step4.classList.add("css-hidden");
    step5.classList.remove("css-hidden");
    servicio = "4";
    if (tipo === "lp") {
      const el = document.getElementById(`css-${calentadores.lp.CM24}`);
      el.classList.remove("css-hidden");
    } else {
      const el = document.getElementById(`css-${calentadores.natural.CM24NAT}`);
      el.classList.remove("css-hidden");
    }
  });

  //restart
  const restart = document.getElementById("restart");
  restart.addEventListener("click", function () {
    step1.classList.remove("css-hidden");
    step2.classList.add("css-hidden");
    step3.classList.add("css-hidden");
    step4.classList.add("css-hidden");
    step5.classList.add("css-hidden");
    const els = document.getElementsByClassName("css-max-w-md");
    for (let i = 0; i < els.length; i++) {
      els[i].classList.add("css-hidden");
    }
    tipo = "";
    distancia = "";
    servicio = "";
  });
  // You can add more code here to interact with the DOM or initialize your application
});
